/**
 * EC店舗設定APIクライアント（FKV3-12808）
 * バックエンドの /{accountCode}/ec-seller-settings を呼び出す
 */

import { apiGet, apiPut } from './client';
import type {
  EcSellerSetting,
  UpdateEcSellerSettingRequest,
} from '@/lib/types/feature/ec-seller-setting';

/** EC店舗設定を取得する（未設定なら空配列が返る） */
export async function getEcSellerSetting(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<EcSellerSetting> {
  return apiGet<EcSellerSetting>(`/${accountCode}/ec-seller-settings`, authHeaders);
}

/**
 * EC店舗設定を保存する（差分ではなく全置換）。
 * 保存後の状態がそのまま返るため、呼び出し側で再取得する必要はない。
 */
export async function updateEcSellerSetting(
  accountCode: string,
  request: UpdateEcSellerSettingRequest,
  authHeaders?: Record<string, string>,
): Promise<EcSellerSetting> {
  return apiPut<EcSellerSetting>(`/${accountCode}/ec-seller-settings`, request, authHeaders);
}
